/* eslint-disable angular/ng_angularelement */
import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalVideo from '../../shared/components/modal-video/modal-video.view.html';
import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';
import modalRecommendProduct from '../../shared/components/modal-recommend-product/modal-recommend-product.view.html';
import modalCommentsController from '../modal-comments/modal-comments.view.html';
import modalSelectModalidadPago from '../../shared/components/modal-select-modalidad-pago/modal-select-modalidad-pago.view.html';

let inject = [
    '$scope',
    'CategoryService',
    '$state',
    '$rootScope',
    'SharedService',
    '$stateParams',
    '$uibModal',
    'ProductDetailService',
    '$timeout',
    'CatalogService',
    'CartService',
    'SessionService',
    '$mdToast',
    'ByFavoritesService'
];

class ProductDetailController {
    constructor($scope,
        CategoryService,
        $state,
        $rootScope,
        SharedService,
        $stateParams,
        $uibModal,
        ProductDetailService,
        $timeout,
        CatalogService,
        CartService,
        SessionService,
        $mdToast,
        ByFavoritesService) {
        this.$state = $state;
        this.$scope = $scope;
        this.CatalogService = CatalogService;
        this.ProductDetailService = ProductDetailService;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.CartService = CartService;
        this.SessionService = SessionService;
        this.CategoryService = CategoryService;
        this.SharedService = SharedService;
        this.$timeout = $timeout;
        this.loanding = false;
        this.$mdToast = $mdToast;
        this.showProductPrice = true;
        this.partSuppliesProduct = [];
        this.featuredProducts = [];
        this.active = 0;
        this.partSustitutesProduct = [];
        this.partSparesProducts =[];
        this.showBottomAddCart = true;
        this.productQuantity = 1;
        this.productId = this.$stateParams.productId || '';
        this.productSlug = this.$stateParams.productSlug || '';
        this.title = document.title;
        this.comments = [];
        this.globalRating = 0;
        this.globalRatingDecimal = 0;
        this.hasCommented = false;
        this.commentDataForm = {};
        this.ratingSelected = false;
        this.attributesDetail;
        this.property = 'date';
        this.reverse = false;
        this.imageVisor = null;
        this.imageZoom = null;

        this.pageNumber = 0;
        this.loadingComments = false;
        this.finishComments = false;

        this.dataCart = {};
        this.dataProducs = {};

        this.ByFavoritesService = ByFavoritesService;

        this.productItems = {};
        // only for adaptative
        this.showComments = false;

        this.originalClonedAttributesArray = null;
        this.colorSizeRelationArray = null;

        this.pageName = "B2B-PAG-22";
        this.SharedService.getCMSBanners(this.pageName).then(response => {
            this.cmsData = response;
        });

        this.productUrl = window.location.href;
    }
    
    $onInit() {
        this.getProductDetail();
    }

    $onDestroy() {
        document.title = this.title;
        var myEl = angular.element(document.querySelector('.zoomContainer'));
        myEl.remove();
    }

    updateFavoriteProducts(product) {

        product.isSettingAsFavorite = true;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        if (userId) {

            let data = {
                'productId': product.id,
                'userId': userId,
                'setFavorite': !product.isFavorite
            };
            this.CatalogService.updateFavoriteProducts(data).then(response => {
                product.isFavorite = !product.isFavorite;
                product.isSettingAsFavorite = false;

                if (!response.error) {
                    this.ByFavoritesService.getResumeProductsFavorites(this.shCtrl.globals.currentUser.userId).then(favoritesResponse => {
                        this.shCtrl.globals.currentUser.favoriteItems = favoritesResponse;
                        this.SessionService.put('globals', this.shCtrl.globals);

                    });
                }

            }).catch(error => {
                product.isSettingAsFavorite = false;
                if (__env.adaptative){
                  this.messageMaterial('Ha ocurrido un error al actualizar el producto');
                }else{
                let options = {
                    title: '',
                    isHtml: false,
                    content: 'Ha ocurrido un error al actualizar el producto',
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };

                this.messageResponse(options);
                }
            });
        }
    }

    onItemRating(rating) {
        this.commentDataForm["rating"] = rating;
        this.ratingSelected = rating === 0;
    }

    openCommentsModal(){

        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {
        }

        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalCommentsController,
            controller: 'ModalCommentsController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                product: () => this.productDetail,
                userId: () => userId
            }
        });
        modalInstance.result.then(result => {

            let options = {
                title: '',
                isHtml: true,
                content: result.message,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
            };
            this.messageResponse(options);

        }).catch(error => {
            console.log(error);
        });
    }

    getProductComments() {

        if (this.loadingComments) return;

        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {
        }

        this.loadingComments = true;
        this.pageNumber++;

        this.ProductDetailService.getProductComments(this.productDetail.id, userId).then(val => {

            if (!val.error) {

                this.globalRating = val.globalRating;
                this.globalRatingDecimal = val.globalRatingDecimal;
                this.comments = [];
                val.data.forEach(value => {
                    this.comments.push({
                        rate: value.puntaje,
                        title: value.titulo,
                        description: value.comentario,
                        user: value.usuario_nombre,
                        date: value.fecha
                    });
                });
            }

            if(val.data.length > 0){
                this.loadingComments = false;
            }else{
                this.finishComments = true;
            }

        }).catch(err => {
            console.log(err);
        });
    }

    submitCommentad(submitForm) {

        if (submitForm.$valid && this.commentDataForm.rating > 0) {

            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            } catch (e) {
            }

            let params = {
                item_id: this.productDetail.id,
                puntaje: this.commentDataForm.rating,
                titulo: this.commentDataForm.title,
                comentario: this.commentDataForm.comment,
                user_id: userId
            };

            this.ProductDetailService.setProductComments(params).then(value => {

                if (!value.error) {
                    this.loadingComments = false;
                    this.finishComments = false;
                    this.pageNumber = 0;
                    this.getProductComments();
                }
                if(__env.adaptative){
                  this.messageMaterial(value.message);
                  this.commentDataForm.comment='';
                  this.commentForm.$setPristine();
                  this.commentForm.$setUntouched();
                }else{
                  let options = {
                    title: '',
                    isHtml: true,
                    content: value.message,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                  };
                  this.messageResponse(options);

                }

            }).catch(err => {
                console.log(err);
            });

        } else {
            angular.forEach(submitForm.$error.required, function (field) {
                field.$setDirty();
            });

            if (this.commentDataForm.rating === 0 || !this.ratingSelected) {
                this.ratingSelected = true;
            }
        }
    }

    getProductDetail() {
        this.loadingProductDetail = true;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {
        }

      this.ProductDetailService.getProductDetail(this.productId, this.productSlug, userId).then(response => {
            this.loadingProductDetail = false;
            try {

                if(response.currentPrice === null && this.shCtrl.globalParams.showProductNotFound) {
                    this.$state.go('home.productNotFound', {productSearchText: response.name});
                }
                
                this.productDetail = response;

                this.originalClonedAttributesArray = this.productDetail.clonedAttributesDetail;
                this.colorSizeRelationArray = this.productDetail.colorSizeRelationArray;

                this.productQuantity = (response.factor_pedido > response.cantidad_minima) ? response.factor_pedido : response.cantidad_minima;

                this.imageVisor = this.productDetail.imagesDetail[0].path + this.productDetail.imagesDetail[0].image;

                this.productoPlantilla = response;
                this.initPluginsProductDetails();

                this.getRelatedProducts();
                this.getProductComments();

                if (!angular.isArray(response.attributesDetail)) {
                    //console.log(response.attributesDetail);
                    this.attributesDetail = response.attributesDetail;
                }

                if (this.productDetail.clonedAttributesDetail.length > 0) {
                    this.showProductPrice = false;
                }

                if (this.productDetail.isTemplate) {
                    this.productTemplateCopy = angular.copy(this.productDetail);
                }
                document.title = this.productDetail.name;
            }
            catch (e) {
                this.$state.go('/404');
            }
        }).catch(reason => {
            this.$state.go('/404');
        });
    }

    setItemToAddToCart(product) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalQuantityCart,
            controller: 'ModalQuantityCartController',
            controllerAs: 'mdCtrl',
            size: 'sm',
            resolve: {
                product: () => product
            }
        });
        modalInstance.result.then(result => {
            if (result.product.id && result.quantity) {
                let userId = '', cart = null;
                try {
                    userId = this.shCtrl.globals.currentUser.userId;
                } catch (e) {
                }
                try {
                    cart = this.shCtrl.cart;
                } catch (e) {
                }

                let validation  = this.SessionService.validateFactorItems(result.quantity,product);
   
                if(validation.error){
    
                    let options = {
                        title: '',
                        isHtml: true,
                        content: validation.message,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                    return;
                }

                this.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(response => {
                    if (!response.error) {
                        // this.$scope.$emit('onUpdateCart');

                        // let modalInstance2 = this.$uibModal.open({
                        //     animation: true,
                        //     template: modalConfirmationCart,
                        //     controller: 'ModalConfirmationController',
                        //     controllerAs: 'mdCtrl',
                        //     size: 'lg',
                        //     resolve: {
                        //         product: () => product
                        //     }
                        // });
                        this.dataCart = {};
                        this.dataProducs = {};
                        this.modalConfirmation(product,result.quantity);
                    } else {
                        let options = {
                            title: '',
                            isHtml: true,
                            content: response.message,
                            size: '',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                        this.messageResponse(options);
                    }
                }).catch(reason => {
                    let options = {
                        title: '',
                        isHtml: false,
                        content: reason,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                });
            }
        }).catch(error => {

        });
    }

    getRelatedProducts() {
        this.loadingRelatedProducts = true;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {
        }

        this.ProductDetailService.getRelatedProducts(this.productDetail.id, userId, this.productSlug).then(response => {
            this.relatedProducts = response;
            response.forEach(item => {

                if (item.id_tipo_relacion == '1') {
                    this.partSuppliesProduct.push(item);
                }
                if (item.id_tipo_relacion == '2') {
                    this.partSustitutesProduct.push(item);
                }
                if (item.id_tipo_relacion == '3'){
                    this.partSparesProducts.push(item);
                }
            });
            this.loadingRelatedProducts = false;
        }).catch(reason => {

        })
    }

    addItemToCart(product, quantity) {
        if (product.id && quantity) {
            let userId = '', cart = null;
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            } catch (e) {
            }
            try {
                cart = this.shCtrl.cart;
            } catch (e) {
            }

            let validation  = this.SessionService.validateFactorItems(quantity,product);
   
            if(validation.error){

                let options = {
                    title: '',
                    isHtml: true,
                    content: validation.message,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
                return;
            }
            
            this.CartService.addItemToCart(product, quantity, null, null, userId, cart).then(response => {
                if (!response.error) {
                    this.dataCart = {};
                    this.dataProducs = {};

                    if(!response.pesoValidoBodega && response.modalidadParametrizada){
                        this.cambiarSucursalVolumenItemMostrarMedioEnvio(response,product, quantity);
                    } else if(!response.pesoValidoBodega && !response.modalidadParametrizada){
                        this.cambiarSucursalVolumenItems(response, cart, product, quantity);
                    } else if(response.pesoValidoBodega && response.modalidadParametrizada){ 
                        // Si el peso de la bodega es valido y la modalidad no esta en el carrito
                        this.showModalSelectModalidadPago(response, product, quantity);
                    } else{
                        this.modalConfirmation(product, quantity);
                    }
                                        
                } else {

                  /*  if (response.agotado) {
                        product.cantidad = response.itemStock;
                        this.CartService.updateItemsNotAvailable(product, quantity, userId);
                    }*/
                    let options = {
                        title: '',
                        isHtml: true,
                        content: response.message,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                }
            }).catch(reason => {
                let options = {
                    title: '',
                    isHtml: false,
                    content: reason,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            });
        }
    }

    static clickgaleria() {
        //click en la imagen con lupa grande para que popup se despliegue.
        $("#product-image-carousel-container ul li a").eq(0).trigger('click');
    }

    recommendProduct() {
        this.$uibModal.open({
            animation: true,
            template: modalRecommendProduct,
            controller: 'ModalRecommendProductController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                product: () => this.productDetail
            }
        });
    }

    clonedAttributesSelected(attribute,index) {
        this.clonedAttributesSelectedLength = 0;
        let vm = this;


        this.clonedProductPrice = '';
        this.showProductPrice = false;
        this.showBottomAddCart = true;
        this.messageClonedProductPrice = '';

        angular.forEach(this.clonedFormData, function (value, key) {
            value = value || '';
            if (value) {
                vm.clonedAttributesSelectedLength++;
            }
        });

        if (this.productDetail.clonedAttributesDetail.length === this.clonedAttributesSelectedLength) {
            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            }
            catch (e) {
            }
            this.loadingClonedProductPrice = true;
            let data = {
                'productTemplateId': this.productTemplateCopy.id,
                'attributes': this.clonedFormData,
                'userId': userId
            };
            this.loadingClonedProductPrice = true;
            this.showBottomAddCart = false;

            this.ProductDetailService.clonedProductPrice(data).then(response => {
                
                this.loadingClonedProductPrice = false;
                this.showBottomAddCart = true;

                if (!response.error) {
                    this.showProductPrice = true;
                    this.productDetail.currentPrice = response.data.currentPrice;
                    this.productDetail.discountValue = response.data.discountValue;
                    this.productDetail.discountPercentage = response.data.discountPercentage;

                    this.productDetail.clonedId = response.data.clonedId;

                    this.productDetail.quote = response.data.quote;
                    this.productDetail.textLabel = response.data.textLabel;
                    this.productDetail.textLabelContinue = response.data.textLabelContinue;
                    this.productDetail.textAction = response.data.textAction;

                    // Replace the template item for the real item
                    this.productQuantity = (response.data.dataItem.factor_pedido > response.data.dataItem.cantidad_minima) ? response.data.dataItem.factor_pedido : response.data.dataItem.cantidad_minima;

                    this.productDetail = response.data.dataItem;
                    this.productDetail.clonedAttributesDetail = this.productTemplateCopy.clonedAttributesDetail;
                    this.loadedItemFromTemplate = true;
                    // Restart pretty photo
                    this.changImage(response.data.dataItem.imagesDetail[0].path,response.data.dataItem.imagesDetail[0].image);
                }
                else {
                    this.messageClonedProductPrice = 'Producto no disponible';
                    this.productDetail = angular.copy(this.productTemplateCopy);
                    this.loadedItemFromTemplate = false;

                }
            }).catch(reason => {
                this.loadingClonedProductPrice = false;
                alert('Error al obtener el precio del producto');
            });

        }
        else {
            // Recover the template
            this.productDetail = angular.copy(this.productTemplateCopy);
            this.loadedItemFromTemplate = false;

            this.productDetail.discountValue = 0;
            this.productDetail.discountPercentage = 0;

        }
        if(index === 0) {
            this.filterAttributesDetail(this.originalClonedAttributesArray,attribute);
        }
        return false;
    }

    increaseProductQuantity() {
       this.productQuantity = parseFloat(this.productQuantity) + ((parseFloat(this.productDetail.factor_pedido)>0)? parseFloat(this.productDetail.factor_pedido):1 );
    }

    getFeaturedProducts() {
        let userId = '';
        try {
            userId = this.shCtrl.currentUser.userId;
        }
        catch (e) {
        }
        this.CatalogService.getFeaturedProducts(userId, 3).then(response => {
            this.featuredProducts = response;
            //this.initRelatedProductsCarousel();
        }).catch(reason => {

        });
    }

    initRelatedProductsCarousel() {
        this.$timeout(() => {
            let owlfeatured = $("#featured-items-slider");
            owlfeatured.owlCarousel({
                items: 1,
                itemsDesktop: [1199, 1],
                itemsDesktopSmall: [979, 1],
                itemsTablet: [768, 1],
                itemsMobile: [479, 1],
                slideSpeed: 400,
                autoPlay: 5000,
                stopOnHover: true,
                navigation: false,
                pagination: false,
                responsive: true,
                mouseDrag: false,
                autoHeight: true
            });

            // Custom Navigation Events Featured
            $("#featured-items-slider-next").click(function () {
                owlfeatured.trigger('owl.next');
            });
            $("#featured-items-slider-prev").click(function () {
                owlfeatured.trigger('owl.prev');
            });
        }, 100);
    }

    decreaseProductQuantity() {
        if (this.productQuantity > 1){
            this.productQuantity -= (this.productDetail.factor_pedido>0)?this.productDetail.factor_pedido:1;
        }
        if(this.productDetail.cantidad_minima>0 && this.productQuantity < this.productDetail.cantidad_minima){
            if(this.productDetail.factor_pedido > this.productDetail.cantidad_minima){
                this.productQuantity=this.productDetail.factor_pedido;
            }else{
                this.productQuantity=this.productDetail.cantidad_minima;
            }
        }else if(this.productDetail.cantidad_minima<0 && this.productQuantity < this.productDetail.cantidad_minima){
            this.productQuantity=1;
        }
    }

    initProductImagesViewer() {
        this.initPluginsProductDetails();
        this.$timeout(() => {
            $('#product-image-carousel-container').find('li:first-child a').mouseover();
        }, 1000);
    }

    openVideo(video) {
        let options = {
            video: video,
            propertySrc: 'url'
        };

        this.$uibModal.open({
            animation: true,
            template: modalVideo,
            controller: 'ModalVideoController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => options
            }
        });
    }

    initPluginsProductDetails() {
        this.$timeout(() => {
            $('.related-slider.flexslider').flexslider({
                animation: "slide",
                selector: ".related-list > li",
                controlNav: false, // false
                prevText: '',
                nextText: '',
                smoothHeight: true,
                slideshowSpeed: 7000
            });
            // Pretty Photo

            // Carousel
            this.carouselContainer = $('#product-carousel');
            if ($.fn.elastislide) {
                this.carouselContainer.elastislide({
                    minItems: 1
                });
            }
            // Product page zoom plugin settings
            this.productImg = $('#product-image');
          if (!__env.adaptative){
            this.changeZoom(this.productImg[0].src);
            if ($.fn.elevateZoom) {
              this.carouselContainer.find('a').on('mouseover', (e) => {
                let ez = $('#product-image').data('elevateZoom'),
                  smallImg = $(this).data('image'),
                  bigImg = $(this).data('zoom-image');
                ez.swaptheimage(smallImg, bigImg);
                e.preventDefault();
              });

            }
          }

        }, 100);
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            backdrop  : options.backdrop ? options.backdrop : 'none',
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }
    messageMaterial(text){
    var mdToast=this.$mdToast;
    this.$mdToast.show({
      hideDelay   : 7000,
      controller  : function () {
        this.closeToast = function(){
          mdToast.hide();
        }

      },
      controllerAs:'toast',
      template : '<md-toast>\n' +
      '  <span class="md-toast-text">'+ text +'</span>\n' +
      '  <md-button ng-click="toast.closeToast()">\n' +
      '    Cerrar\n' +
      '  </md-button>\n' +
      '</md-toast>'
    });
  }
    changImage(path, img) {

        this.imageVisor = path + img;
        if(!__env.adaptative){
          this.imageZoom = path + img;
          this.changeZoom(this.imageZoom);
        }
    }
    changeZoom(path) {
        this.productImg.data('zoom-image', path).elevateZoom({
            responsive: true, // simple solution for zoom plugin down here // it can cause bugs at resize
            zoomType: (self.mobile || $(window).width() < 768) ? 'inner' : 'window', // you can use 'inner' or 'window' // change inner and go to product.html page and see zoom plugin differances
            borderColour: '#d0d0d0',
            cursor: "crosshair",
            borderSize: 3,
            lensSize: 100,
            lensShape: "square",
            lenszoom: true,
            easingDuration: 1000,
            lensOpacity: 1,
            scrollZoom: true,
            zoomWindowWidth: 400,
            zoomWindowHeight: 400,
            lensColour: 'rgba(255, 255, 255, 0.25)'
        });
    }

    modalConfirmation(products, quantity) {

        this.productAdded = products;
        this.productAdded.image = products.imagesDetail[0].path + products.imagesDetail[0].image;
        this.productAdded.price = products.itemPrice;
        this.productAdded.discount = products.discountValue;
        this.productAdded.ivaValue = products.taxValue;
        this.productAdded.quantity = quantity;
        //this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue) * quantity;
        this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue + products.taxImpConsumoValue) * quantity;

        if (__env.adaptative) {
            this.messageMaterial(products.name + ' Ha sido agregado correctamente')
        } else {
            $('#ModalproductDetail').modal('toggle');
        }

        this.$scope.$emit('onUpdateCart', 'modalResponseItems');
    }

    showModalSelectModalidadPago(modalidadesPago, product,quantity) {

        let options = {
            userData: this.shCtrl.globals,
            branches: this.shCtrl.globals.currentUser.operatingCenters,
            currentBranch: this.shCtrl.globals.currentClient.operatingCenter,
            cmsMessage: this.shCtrl.globalParams.cmsInfo,
            modalidadesPago: modalidadesPago
        };
        let modalInstance = this.$uibModal.open({
            animation: true,
            static: true,
            template: modalSelectModalidadPago,
            controller: 'ModalSelectModalidadController',
            controllerAs: 'mdCtrl',
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(result => {
            this.modalConfirmation(product, quantity);
        }).catch(reason => {

        });
    }

    cambiarSucursalVolumenItems(response, cart , product, quantity) {
        let cartId = cart.cartId
        let responseData = response
        this.CartService.getShippingMode(cartId).then(response => {
            if (response.modalidad) {
                this.setSucursalesPorModalidad(response,cartId,product, quantity);
            } else {
                this.obtenerSucursalSecundaria(cartId, product, quantity);
            }
        });
    }

    setSucursalesPorModalidad(response, cartId, product, quantity) {
        let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
        let idUsuario = this.shCtrl.globals.currentUser.userId;
        let currentClient  = this.SessionService.get('currentClient');
        let idSucursalActual = currentClient.operatingCenter.id;
        let data = {
            'userId': idUsuario,
            'ciudadId': idCiudad
        };
        let tipoModalidad = response.modalidad.tipo_modalidad;
        // Si la modalidad es recoge 
        if (tipoModalidad == 0) {
            this.CartService.getSecondaryBranch(data).then(response => {
                let idSucursalSecundaria = response.listaSucursales[0].id;
                if (idSucursalSecundaria != null) {
                    if(idSucursalSecundaria != idSucursalActual){
                        this.setSucursalSecundariaRecogeEntrega(idSucursalSecundaria, idUsuario, product, quantity);
                    } else{
                        this.modalConfirmation(product, quantity);
                    }  
                }
            });
            this.CartService.updateDateCart(cartId).then(response => {
                return response;
            });
            // Si es a domicilio 
        } else {
            this.CartService.getSecondaryBranch(data).then(response => {
                let idSucursalSecundaria = response.listaSucursales[0].id;
                let idCiudad = response.listaSucursales[0].ciudad_id;

                if (idCiudad != null && idSucursalSecundaria != null && cartId != null) {
                    this.CartService.updatePromiseCart(cartId, idSucursalSecundaria, idCiudad).then(response => {
                        let aplicaServicioDescargue = response.aplicaServicioDescargue;
                        if (idSucursalSecundaria != null) {
                            if(idSucursalSecundaria != idSucursalActual){
                                this.setSucursalSecundariaTipoDomicilio(idSucursalSecundaria, idUsuario, aplicaServicioDescargue, product, quantity);
                            } else{
                                this.modalConfirmation(product, quantity);
                            }  
                        }
                    });
                }
            });
        }
    }

    setSucursalSecundariaRecogeEntrega(idSucursal, userId, product, quantity) {

        let mensajeCambioSucursal = '';
        let mensajeCambioHorarioBodega = '';
        let allMessage = [];
        try {
            mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
            mensajeCambioHorarioBodega = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_HORARIO_BODEGA;
            allMessage.push(mensajeCambioSucursal);
            allMessage.push(mensajeCambioHorarioBodega);            

        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
                    this.shCtrl.userData.globals.currentClient.seller = response.seller;

                    this.$rootScope.$broadcast('actualizarHeader',response.branch);
                    this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId }).then(response => {
                        if (!response.error) {
                            if (allMessage !== null) {
                                this.showModalAllMessage(allMessage, product, quantity);
                            }
                        }
                    });
                } catch (e) {
                }
            } else {
                console.log('Ocurrio un erro al cambiar la sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    setSucursalSecundariaTipoDomicilio(idSucursal, userId, aplicaServicioDescargue,product, quantity) {

        let mensajeCambioSucursal = '';
        let mensajeDestinoNoDisponilble = '';
        let mensajeCambioPromesa = '';
        let allMessage =[];
        
        try {
            mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
            mensajeCambioPromesa = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_PROMESA;
            allMessage.push(mensajeCambioSucursal);
            allMessage.push(mensajeCambioPromesa);
            
            if (!aplicaServicioDescargue) {
                mensajeDestinoNoDisponilble =  this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATITVO_DESTINOS_NO_DISPONIBLES;
                allMessage.push(mensajeDestinoNoDisponilble);
            } 

        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
                    this.shCtrl.userData.globals.currentClient.seller = response.seller;

                    this.$rootScope.$broadcast('actualizarHeader',response.branch);
                    this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId }).then(response => {
                        if (!response.error) {
                            if (allMessage !== null) {
                                this.showModalAllMessage(allMessage, product, quantity);
                            }
                        }
                    });
                } catch (e) {
                }
            } else {
                console.log('ocurrio un error al cambiar de sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    cambiarSucursalVolumenItemMostrarMedioEnvio(response,product, quantity) {
        let responseData = response
        let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
        let idUsuario = this.shCtrl.globals.currentUser.userId;
        let currentClient  = this.SessionService.get('currentClient');
        let idSucursalActual = currentClient.operatingCenter.id;
        let data = {
            'userId': idUsuario,
            'ciudadId': idCiudad
        };
        this.CartService.getSecondaryBranch(data).then(response => {
            let idSucursalSecundaria = response.listaSucursales[0].id;
            if (idSucursalSecundaria != null) {
                if(idSucursalSecundaria != idSucursalActual){
                    this.setSucursalSecundariaMostrarModalMedioEnvio(idSucursalSecundaria, idUsuario, responseData, product, quantity);
                } else{
                    this.modalConfirmation(product, quantity);
                }  
            }
        });


    }

    setSucursalSecundariaMostrarModalMedioEnvio(idSucursal, userId, mediosEnvio,product, quantity) {
        let mensajeCambioSucursal = '';
        try {
            mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
                    this.shCtrl.userData.globals.currentClient.seller = response.seller;
                    this.$rootScope.$broadcast('actualizarHeader',response.branch);
                    this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId}).then(response =>{
                        if (!response.error) {
                          if (mensajeCambioSucursal !== '') {
                            let optionsMessage = {
                              title: 'Actualización de precios',
                              isHtml: true,
                              content: mensajeCambioSucursal,
                              size: '',
                              showBottonCancel: false,
                              textActionCancel: '',
                              textAction: 'Aceptar'
                            };
                            let modalInstance = this.$uibModal.open({
                              animation: true,
                              template: modalConfirmation,
                              controller: 'ModalResponseController',
                              controllerAs: 'mdCtrl',
                              backdrop: 'static',
                              size: 'md',
                              resolve: {
                                modalOptions: () => optionsMessage
                              }
                            });
                            modalInstance.result.then(() => {
                              this.showModalSelectModalidadPago(mediosEnvio, product, quantity);
                            }).catch(() => {
            
                            });
                          }
                        }
                      });
                } catch (e) {
                }
            } else {
                alert('Ocurrion un error al mostrar los medios de envio')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    showModalAllMessage(allMesagge, product, quantity){
        let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

        for(let i=0; i < allMesagge.length; i++){
            contentDynamic += `
                                <ul><li>` + allMesagge[i] + `</li></ul>`;
        }

        if(contentDynamic != ''){
            let optionsMessage = {
                title: 'Actualización de precios',
                isHtml: true,
                content: contentDynamic,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar',
                backdrop: 'static'
            };

            let modalInstance = this.$uibModal.open({
                animation: true,
                template: modalConfirmation,
                controller: 'ModalResponseController',
                controllerAs: 'mdCtrl',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    modalOptions: () => optionsMessage
                }
            });
            modalInstance.result.then(() => {                
                this.modalConfirmation(product, quantity);
            }).catch(() => {

            });
        }
    }

    obtenerSucursalSecundaria(cartId, product, quantity) {
        let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
        let idUsuario = this.shCtrl.globals.currentUser.userId;
        let currentClient  = this.SessionService.get('currentClient');
        let idSucursalActual = currentClient.operatingCenter.id;
        let data = {
            'userId': idUsuario,
            'ciudadId': idCiudad
        };
        // Si la modalidad es recoge 
        if (data != null) {
            this.CartService.getSecondaryBranch(data).then(response => {
                let idSucursalSecundaria = response.listaSucursales[0].id;
                if (idSucursalSecundaria != null) {
                    if(idSucursalSecundaria != idSucursalActual){
                        this.setSucursalSecundariaSinModalidad(idSucursalSecundaria, idUsuario, product, quantity);
                    } else{
                        this.modalConfirmation(product, quantity);
                    }  
                }
            });
            this.CartService.updateDateCart(cartId).then(response => {
                return response;
            });
        }
      }
      
      setSucursalSecundariaSinModalidad(idSucursal, userId, product, quantity) {
      
        let mensajeCambioSucursal = '';
        let allMessage = [];
        try {
            mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
            allMessage.push(mensajeCambioSucursal);
        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
                    this.shCtrl.userData.globals.currentClient.seller = response.seller;

                    this.$rootScope.$broadcast('actualizarHeader', response.branch);
                    this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId }).then(response => {
                        if (!response.error) {
                            if (allMessage !== null) {
                                this.showModalAllMessage(allMessage, product, quantity);
                            }
                        }
                    });
                } catch (e) {
                }
            } else {
                console.log('Ocurrio un erro al cambiar la sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
      }    

          //Intersecta arrays originalClonedAttributesArray con this.colorSizeRelationArray
    // Para hallar que tallas se deben mostrar segun que color.
    filterAttributesDetail(originalClonedAttributesArray,attribute) {

        //  const extensioncolor = Object.keys(this.clonedFormData)[0]

        // //logica de seleccion
        if(Object.keys(this.clonedFormData).length > 0) {
            //Encontrando nombre de color seleccionado
            // var selectedColorName = originalClonedAttributesArray[0].valuethis.clonedFormData.extensioncolor];
            const objectKey = Object.values(this.clonedFormData);
            var selectedColorName =  objectKey[0];
  
            //Hallando tallas disponibles para ese color
            var availableSizesToColor = this.colorSizeRelationArray[selectedColorName];
  
            // Crear copia del array de tallas
            const copyArray = angular.copy(originalClonedAttributesArray[1].value);

            if(Object.keys(availableSizesToColor).length == 1){
                const keyObjectArr = Object.keys(availableSizesToColor)
                const valueObjecArr = Object.values(availableSizesToColor)[0]
                availableSizesToColor = [];
                availableSizesToColor[keyObjectArr] = valueObjecArr;
            }
            //Hallando claves en array de tallas
            const sizeAvailableKeys = [];
            if(!Array.isArray(availableSizesToColor)){
                for (let prop in  availableSizesToColor) {
                // const foundItem = Object.keys(copyArray).find(key => copyArray[key] == `${availableSizesToColor[prop]}`);
                    // if(foundItem != undefined) { 
                        // sizeAvailableKeys.push(foundItem); 
                    // }
                    const foundItem = Object.keys(copyArray).find(key => key == prop);
                    if(foundItem != undefined) { 
                        sizeAvailableKeys.push(foundItem); 
                    }
                }
            }else{
                availableSizesToColor.forEach(function(item) {
                    const foundItem = Object.keys(copyArray).find(key => copyArray[key] === item);
                    if(foundItem != undefined) { sizeAvailableKeys.push(foundItem); }
                });
            }
           
            //hallando llaves a borrar
            const keysToDelete = [];
            Object.keys(copyArray).forEach(function(key) {
                const keyFounded = sizeAvailableKeys.find(el => el === key);
                if(keyFounded == undefined) { keysToDelete.push(key); }
            });
            //Borrando claves de array de tallas
            keysToDelete.forEach(function(key) {
                delete copyArray[key];
            });
  
            this.productDetail.clonedAttributesDetail[1].value = angular.copy(copyArray);
            this.productTemplateCopy.clonedAttributesDetail[1].value = angular.copy(copyArray);
        }
        this.clonedFormData.extensiontalla = null;
    }

}

ProductDetailController.$inject = inject;

export default ProductDetailController;




/** WEBPACK FOOTER **
 ** ./www/components/catalog/product-detail/product-detail.controller.js
 **/